import { FC, useEffect, useMemo } from "react";
import { useTranslation, Trans } from "react-i18next";
import DOMPurify from "dompurify";

import { Icon, Panel } from "capitalrx-components-2.0/lib/general";
import { Shelf, Stack } from "capitalrx-components-2.0/lib/layout";
import { Bold, Paragraph, Semibold } from "capitalrx-components-2.0/lib/typography";

import { MemberNotification } from "@/App/api/notification";
import { ClientAwareLink } from "@/App/components/ClientAwareLink";
import { ANALYTIC_EVENTS, logEvent } from "@/App/service/analyticsService";

export const LCAMessage: FC<{ readonly memberNotification: MemberNotification }> = ({ memberNotification }) => {
  const { t: translate } = useTranslation();
  const sanitizedMessage = useMemo(() => {
    const mainMessage = memberNotification.json_message.main_message;
    return mainMessage.map((message) => DOMPurify.sanitize(message));
  }, []);
  const claimId = memberNotification.claim_id;
  const supList = memberNotification.json_message.supplemental_message;
  const supTotal = memberNotification.json_message.total_per_fill;

  useEffect(() => {
    logEvent(ANALYTIC_EVENTS.INBOX.LOW_COST_ALTERNATIVE.lcaMessageOpen);
  }, []);

  return (
    <Stack testId="lca-message-container">
      { }
      <p data-testid="p-sanitized-message-0" dangerouslySetInnerHTML={{ __html: sanitizedMessage[0] }}></p>
      { }
      <p data-testid="p-sanitized-message-1" dangerouslySetInnerHTML={{ __html: sanitizedMessage[1] }}></p>
      { }
      <p data-testid="p-sanitized-message-2" dangerouslySetInnerHTML={{ __html: sanitizedMessage[2] }}></p>
      <ClientAwareLink testId="" analyticsEvent={ANALYTIC_EVENTS.INBOX.LOW_COST_ALTERNATIVE.viewClaimMessage} to={`/claims-history/${claimId}`}>
        View Related Claim
      </ClientAwareLink>

      <Panel>
        <Bold>{translate("MESSAGE_DETAIL.lcaMessage.ourRecommendation")}</Bold>
        {supList.map((drug) => (
          <Shelf key={drug.alternative_drug_name} testId={`drug-${drug.alternative_drug_name}-container`}>
            <Icon name="pill-bottle" color="green" />
            <Semibold testId={`drug-${drug.alternative_drug_name}-name`}>{drug.alternative_drug_name}</Semibold>
            {drug.patient_pay_amount}
            <Shelf.Spacer />
          </Shelf>
        ))}

        {supTotal && (
          <Trans
            i18nKey="MESSAGE_DETAIL.lcaMessage.totalPerFill"
            values={{
              supTotal,
            }}
            components={{ Semibold: <Semibold /> }}
          />
        )}
        <Paragraph>
          {translate("MESSAGE_DETAIL.lcaMessage.memberResponsability")}
        </Paragraph>
      </Panel>
    </Stack>
  );
};
